<section class="aic">

  <% if ( state !== 'ready' ) { %>
    <div class="dash-msg">
      <span class="dash-msg__icon"><i class="icon icon--<%= state === 'error' ? 'triangle-alert' : 'sparkles' %>"></i></span>
      <h2><%= state === 'error' ? _lcs( 'KI-Kosten konnten nicht geladen werden' ) : _lcs( 'Lade KI-Kosten …' ) %></h2>
      <p><%= state === 'error' ? _lcs( 'Bitte versuche es später erneut.' ) : _lcs( 'Einen Moment bitte.' ) %></p>
    </div>
  <% } else { %>

  <div class="aic__filters">
    <label class="aic__month">
      <i class="icon icon--calendar"></i>
      <span class="aic__month-label"><%= _lcs( 'Monat' ) %></span>
      <select class="aic__select" data-id="month">
        <% monthOptions.forEach( function( m ) { %>
          <option value="<%= m.value %>"<%= m.selected ? ' selected' : '' %>><%= m.label %></option>
        <% } ); %>
      </select>
    </label>
    <span class="aic__rate"><i class="icon icon--info"></i> <%= rateNote %></span>
  </div>

  <!-- ===== KPIs: the selected month against its neighbours ===== -->
  <section class="kpi-grid">
    <div class="kpi">
      <div class="kpi__top">
        <span class="kpi__label"><%= kpi.monthLabel %></span>
        <span class="kpi__icon"><i class="icon icon--wallet"></i></span>
      </div>
      <div class="kpi__value"><%= kpi.month %></div>
      <span class="kpi__delta <%= kpi.deltaClass %>"><i class="icon icon--<%= kpi.deltaIcon %>"></i> <span><%= kpi.delta %></span></span>
    </div>

    <div class="kpi">
      <div class="kpi__top">
        <span class="kpi__label"><%= kpi.forecastLabel %></span>
        <span class="kpi__icon kpi__icon--sand"><i class="icon icon--trending-up"></i></span>
      </div>
      <div class="kpi__value"><%= kpi.forecast %></div>
      <span class="kpi__delta kpi__delta--flat"><i class="icon icon--gauge"></i> <span><%= kpi.forecastSub %></span></span>
    </div>

    <div class="kpi">
      <div class="kpi__top">
        <span class="kpi__label"><%= _lcs( 'Gastgeber / Plattform' ) %></span>
        <span class="kpi__icon kpi__icon--sky"><i class="icon icon--briefcase"></i></span>
      </div>
      <div class="kpi__value"><%= kpi.clients %> <small>/ <%= kpi.platform %></small></div>
      <span class="kpi__delta kpi__delta--flat"><i class="icon icon--users"></i> <span><%= kpi.clientCount %></span></span>
    </div>

    <div class="kpi">
      <div class="kpi__top">
        <span class="kpi__label"><%= _lcs( 'Letzte 12 Monate' ) %></span>
        <span class="kpi__icon"><i class="icon icon--badge-euro"></i></span>
      </div>
      <div class="kpi__value"><%= kpi.total %></div>
      <span class="kpi__delta kpi__delta--flat"><i class="icon icon--activity"></i> <span><%= kpi.totalSub %></span></span>
    </div>
  </section>

  <% if ( unpriced > 0 ) { %>
    <p class="aic__warn"><i class="icon icon--triangle-alert"></i> <%= _lcs( '{count} Anfragen ohne hinterlegten Preis', { count: unpriced, n: unpricedText } ) %></p>
  <% } %>

  <!-- ===== Trend ===== -->
  <div class="widget">
    <div class="widget__head">
      <h3 class="widget__title"><i class="icon icon--bar-chart-3"></i> <%= _lcs( 'Kosten pro Monat' ) %></h3>
      <div class="an-period" role="group" aria-label="<%= _lcs( 'Aufteilung' ) %>">
        <button type="button" class="an-period__btn" data-split="feature" aria-pressed="<%= split === 'feature' ? 'true' : 'false' %>"><%= _lcs( 'Nach Funktion' ) %></button>
        <button type="button" class="an-period__btn" data-split="payer" aria-pressed="<%= split === 'payer' ? 'true' : 'false' %>"><%= _lcs( 'Gastgeber / Plattform' ) %></button>
        <button type="button" class="an-period__btn" data-split="model" aria-pressed="<%= split === 'model' ? 'true' : 'false' %>"><%= _lcs( 'Nach Modell' ) %></button>
      </div>
    </div>
    <div class="widget__body">
      <div class="chart aic__chart" data-id="chart-months"></div>
    </div>
  </div>

  <div class="widget">
    <div class="widget__head">
      <h3 class="widget__title"><i class="icon icon--activity"></i> <%= _lcs( 'Kosten pro Tag' ) %></h3>
      <span class="widget__note"><%= _lcs( 'Letzte 60 Tage' ) %></span>
    </div>
    <div class="widget__body">
      <div class="chart aic__chart aic__chart--line" data-id="chart-days"></div>
    </div>
  </div>

  <div class="aic-cols">

    <!-- ===== Top 10 clients of the selected month ===== -->
    <div class="widget">
      <div class="widget__head">
        <h3 class="widget__title"><i class="icon icon--trophy"></i> <%= _lcs( 'Top 10 Gastgeber' ) %></h3>
        <span class="widget__note"><%= monthName %></span>
      </div>
      <div class="widget__body widget__body--flush">
        <% if ( topClients.length === 0 ) { %>
          <p class="aic__empty"><%= _lcs( 'In diesem Monat hatte kein Gastgeber KI-Kosten.' ) %></p>
        <% } else { %>
          <div class="aic__scroll">
            <table class="an-table aic-table">
              <thead>
                <tr>
                  <th class="an-table__rank">#</th>
                  <th><%= _lcs( 'Gastgeber' ) %></th>
                  <th class="an-table__num"><%= _lcs( 'Anfragen' ) %></th>
                  <th class="an-table__num"><%= _lcs( 'Kosten' ) %></th>
                  <th class="aic-table__budget"><%= _lcs( 'Monatsbudget' ) %></th>
                  <th class="an-table__num"><%= _lcs( 'Anteil' ) %></th>
                  <th class="aic-table__go"></th>
                </tr>
              </thead>
              <tbody>
                <% topClients.forEach( function( c ) { %>
                  <tr class="aic-table__row" data-org="<%= c.organisationId %>" tabindex="0">
                    <td class="an-table__rank"><%= c.rank %></td>
                    <td>
                      <span class="an-table__name<%= c.isDeleted ? ' aic-table__deleted' : '' %>"><%= c.name %></span>
                      <% if ( c.email ) { %><br><span class="an-table__slug"><%= c.email %></span><% } %>
                    </td>
                    <td class="an-table__num"><%= c.requests %></td>
                    <td class="an-table__num aic-table__cost"><%= c.cost %></td>
                    <td class="aic-table__budget">
                      <% if ( c.budgetPercent !== null ) { %>
                        <span class="aic-meter aic-meter--<%= c.budgetTone %>"><span style="width: <%= Math.min( c.budgetPercent, 100 ) %>%;"></span></span>
                        <span class="aic-meter__text"><%= _lcs( '{percent} von {budget}', { percent: c.budgetPercent + ' %', budget: c.budget } ) %></span>
                      <% } else { %>
                        <span class="an-table__slug">—</span>
                      <% } %>
                    </td>
                    <td class="an-table__num"><%= c.share %></td>
                    <td class="aic-table__go"><i class="icon icon--chevron-right"></i></td>
                  </tr>
                <% } ); %>
              </tbody>
            </table>
          </div>
          <p class="aic__foot"><%= clientNote %></p>
        <% } %>
        <button type="button" class="aic-platform" data-org="platform">
          <span class="aic-platform__icon"><i class="icon icon--layers"></i></span>
          <span class="aic-platform__text">
            <span class="aic-platform__title"><%= _lcs( 'Plattform-eigene Kosten' ) %></span>
            <span class="aic-platform__sub"><%= _lcs( 'Importe, nächtliche Übersetzungen, Einrichtung bei Registrierung' ) %></span>
          </span>
          <span class="aic-platform__value"><%= kpi.platform %></span>
          <i class="icon icon--chevron-right"></i>
        </button>
      </div>
    </div>

    <div class="aic-side">
      <div class="widget">
        <div class="widget__head">
          <h3 class="widget__title"><i class="icon icon--sparkles"></i> <%= _lcs( 'Nach Funktion' ) %></h3>
          <span class="widget__note"><%= monthName %></span>
        </div>
        <div class="widget__body">
          <% if ( monthFeatures.length === 0 ) { %>
            <p class="aic__empty aic__empty--inline"><%= _lcs( 'Keine KI-Anfragen in diesem Monat.' ) %></p>
          <% } else { %>
            <div class="chart aic__chart aic__chart--donut" data-id="chart-features"></div>
          <% } %>
        </div>
      </div>

      <div class="widget">
        <div class="widget__head">
          <h3 class="widget__title"><i class="icon icon--layers"></i> <%= _lcs( 'Modelle' ) %></h3>
          <span class="widget__note"><%= monthName %></span>
        </div>
        <div class="widget__body widget__body--flush">
          <% if ( monthModels.length === 0 ) { %>
            <p class="aic__empty"><%= _lcs( 'Keine KI-Anfragen in diesem Monat.' ) %></p>
          <% } else { %>
            <table class="an-table">
              <thead>
                <tr>
                  <th><%= _lcs( 'Modell' ) %></th>
                  <th class="an-table__num"><%= _lcs( 'Anfragen' ) %></th>
                  <th class="an-table__num"><%= _lcs( 'Kosten' ) %></th>
                </tr>
              </thead>
              <tbody>
                <% monthModels.forEach( function( m ) { %>
                  <tr>
                    <td class="aic-table__mono"><%= m.model %></td>
                    <td class="an-table__num"><%= m.requests %></td>
                    <td class="an-table__num"><%= m.cost %></td>
                  </tr>
                <% } ); %>
              </tbody>
            </table>
            <p class="aic__foot"><%= tokenNote %></p>
          <% } %>
        </div>
      </div>
    </div>

  </div>

  <% } %>
</section>
